import React, { useState, useCallback } from 'react';
import { ChromePicker } from 'react-color';
import PropTypes from 'prop-types';

const popover = {
  position: 'absolute',
  zIndex: '2',
};

const cover = {
  position: 'fixed',
  top: '0px',
  right: '0px',
  bottom: '0px',
  left: '0px',
};

const swatch = {
  padding: '5px',
  background: '#fff',
  borderRadius: '1px',
  boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
  display: 'inline-block',
  cursor: 'pointer',
};

const colorStyle = (color) => ({
  width: '100px',
  height: '24px',
  borderRadius: '2px',
  background: color,
});

function ColorPickerInput({ value, onChange }) {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = useCallback(() => {
    setDisplayColorPicker((prev) => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setDisplayColorPicker(false);
  }, []);

  const handleChange = useCallback((color) => {
    onChange(color.hex);
  }, [onChange]);

  return (
    <div>
      <div style={swatch} onClick={handleClick}>
        <div style={colorStyle(value)} />
      </div>
      {displayColorPicker ? (
        <div style={popover}>
          <div style={cover} onClick={handleClose} />
          <ChromePicker color={value} onChange={handleChange} disableAlpha />
        </div>
      ) : null}
    </div>
  );
}

ColorPickerInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

ColorPickerInput.defaultProps = {
  value: '#0091FF', // Default color
  onChange: () => {},
};

export default ColorPickerInput;